<template>
  <div>
    <Card>
      <ui-treeview
        :items="rows"
        class="main-table"
      >
        <template #default="{ item }">
          {{ item.name }}
        </template>
      </ui-treeview>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

const rows = [
  {
    id: 1,
    name: 'level 1',
    children: [
      {
        name: 'level 123',
        id: 2,
      },
      {
        name: 'level 123',
        id: 3,
      },
    ],
  },
  {
    id: 4,
    name: 'level 2',
    children: [
      {
        id: 5,
        name: 'level 223',
      },
      {
        id: 6,
        name: 'level 223',
        children: [
          {
            id: 7,
            name: 'level 223',
          },
          {
            id: 8,
            name: 'level 223',
          },
        ],
      },
    ],
  },
];
</script>
